import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { RiMore2Fill } from "react-icons/ri";
import { CardContent, Collapse } from "@mui/material";
import { createAppointment } from "../services/patientRegistrationRequesApi";
import { getTokenClinicDoctor } from "../utils/commonUtils";
import { calculateAgeR } from "../../clinic/utils/commonUtils";
import { showToast } from "../utils/toastUtils";

const PatientCard = ({
  patient,
  index,
  showDetails,
  toggleDetails,
  avatarColor
}) => {
  const [age, setAge] = useState(null);
  const [clinicId, setClinicId] = useState();
  const [doctorId, setDoctorId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const preViousState = location?.state ?? {};
  useEffect(() => {
    const getClinicAndDoctor = getTokenClinicDoctor();

    setClinicId(getClinicAndDoctor.clinicId);
    setDoctorId(getClinicAndDoctor.doctorId);

    const birthYear = new Date(patient.userDetails.date_of_birth).getFullYear();
    const currentYear = new Date().getFullYear();
    const calculatedAge = currentYear - birthYear;
    //setAge(calculatedAge);
    setAge(calculateAgeR(patient.userDetails.date_of_birth));
  }, []);

  const handleCreateAppointmentForMember = async (patientId) => {
    try {
      if (doctorId && clinicId) {
        const response = await createAppointment(patientId, doctorId, clinicId);
        if (response?.status) {
          showToast(response?.message, "success");
        }else{
          showToast(response?.message, "error");
        }

        localStorage.setItem("clinicId", clinicId);
        localStorage.setItem("doctorId", doctorId);
        localStorage.setItem("patientId", response.data.patient_id);
        localStorage.setItem("appointmentNumber", response.data.appointment_number);

        navigate("/patient/appointmentConfirmation", {
          state: { ...preViousState },
        });
      }
    } catch (error) {
      console.error("Error creating appointment for member:", error);
    }
  };

  const getInitialLetter = (name) =>
    (name && name.charAt(0).toUpperCase()) || "";

  return (
    <Card
      sx={{
        mb: 2,
        boxShadow: "0 1px 6px rgba(0,0,0,0.1)",
        border: "1px solid #e8e8e8",
      }}
    >
      <CardActionArea
        onClick={() => handleCreateAppointmentForMember(patient.patient_id)}
      >
        <CardHeader
          avatar={
            <Typography
              // to={`/patient/appointmentConfirmation`}
              style={{ textDecoration: "none" }}
            >
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                variant="dot"
              >
                <Avatar
                  src={`images/fam/${patient.famPicture}`}
                  style={{ backgroundColor: avatarColor }}
                >
                  {getInitialLetter(patient.userDetails.first_name)}
                </Avatar>
              </Badge>
            </Typography>
          }
          action={
            <IconButton
              aria-label="settings"
              onClick={() => toggleDetails(index)}
            >
              <RiMore2Fill />
            </IconButton>
          }
          subheader={
            <Typography
              // to={`/patient/appointmentConfirmation`}
              style={{ textDecoration: "none", color: "#090b1a" }}
              sx={{
                color: "#090b1a",
              }}
            >
              <Typography variant="caption" component="div">
                {patient.relationType}
              </Typography>
            </Typography>
          }
          title={
            <Typography
              // to={`/patient/appointmentConfirmation`}
              style={{
                textDecoration: "none",
                display: "flex",
                color: "#090b1a",
              }}
            >
              <Typography variant="subtitle1" component="span">
                {patient.userDetails.first_name} {patient.userDetails.last_name}
              </Typography>
            </Typography>
          }
        />
        <CardContent
          sx={{
            bgcolor: "#f5f8ff",
            py: 1,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Age: <span className=" text-gray-800  font-semibold">{age}</span>
          </Typography>
          {/* <Typography variant="body2" className=" text-gray-800  font-semibold">
            Gender: {patient.userDetails.gender}
          </Typography> */}
        </CardContent>
      </CardActionArea>
      <Collapse in={showDetails[index]} timeout="auto" unmountOnExit>
        <CardContent sx={{ bgcolor: "background.paper" }}>
          {/* Rest of the details here */}
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default PatientCard;
